import { render, staticRenderFns } from "./CancelledAlert.vue?vue&type=template&id=655fe864"
import script from "./CancelledAlert.vue?vue&type=script&lang=js"
export * from "./CancelledAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports